import { AxiosStatic, AxiosPromise } from 'axios';
import { SearchCustomerInformation, SearchParams, SettingsInformation, CustomersInformation } from '../models/api-client';

class CallCenterService {
  public controllerUri: string;

  constructor(public axios: AxiosStatic, public baseUrl: string) {
    this.axios = axios;
    this.baseUrl = baseUrl;
    this.controllerUri = 'CallCenter';
  }

  getSelectedCustomer(customerNumber: number): AxiosPromise<CustomersInformation> {
    return this.axios.get(`${this.baseUrl + this.controllerUri}/GetSelectedCustomer/${customerNumber}`);
  }

  getCallCenterCustomer(searchParams: SearchParams): AxiosPromise<SearchCustomerInformation> {
    return this.axios.post(`${this.baseUrl + this.controllerUri}/SearchCustomer/`, searchParams);
  }

  getSettings(): AxiosPromise<SettingsInformation> {
    return this.axios.get(`${this.baseUrl + this.controllerUri}/GetSettings/`);
  }

  saveSettings(settings: SettingsInformation): AxiosPromise<boolean> {
    return this.axios.post(`${this.baseUrl + this.controllerUri}/SaveSettings/`, settings);
  }
}

export default CallCenterService;
